import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { RateRequestService } from 'src/app/core-services/raterequest.services';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
// import { AlertTriangle } from 'angular-feather/icons';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { id } from 'date-fns/locale';
import { ElementRef } from '@angular/core';
import { UserRole, UserSelectedPlan, RaterequestStatus, BookingFeeAndLumpsum, GetDurationFilterValues, DurationFilter } from 'src/app/Enum/Enum';
// import { $ } from 'protractor';
import 'jquery';
import * as $ from 'jquery';
import { OfferedRateModel } from 'src/app/models/OfferedRateModel';
import { DatePipe } from '@angular/common';
import { BookingViewModel, PaymentDetails } from 'src/app/models/BookingViewModel';
import { BookingService } from '../../landing/services/booking.service';
import { PortService } from 'src/app/core-services/port.service';
import { environment } from 'src/environments/environment';
import { UserService } from 'src/app/core-services/user.service';
import * as moment from 'moment';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BookingRequestVM } from 'src/app/models/booking-request.model';
declare var paypal: any;

@Component({
  selector: 'app-rate-request-list',
  templateUrl: './rate-request-list.component.html',
  styleUrls: ['./rate-request-list.component.scss'],
  providers: [ConfirmationService, DatePipe]
})

export class RateRequestListComponent implements OnInit {
  // cars: Car[];
  rateRequestUserDetail: any;
  RatelistData: any[];
  RateRequsetId: any;
  submitted: boolean = false;
  isadmin: boolean = false;
  ratedropdown: any = [];
  freightratedropdown: any = [];
  otherratedropdown: any = [];
  currentUser: any;
  minDate: Date;
  rageYears: string;
  frmport: string;
  toport: string;
  offeredamount: number;
  statusrate = false;
  selectedBAFname: any[];
  selectedRatename: any[];
  selectedCafname: any[];
  selectedThcname: any[];
  selectedOtherchargesname: any[];
  offeredRateReason: string;
  offeredRateId: number = 0;
  pageSize: number;
  totalcount: number;
  currentPage: number;
  SerachField: string = "";
  IsRateEdit: boolean = false;
  iscafbasisReadonly: boolean = true;
  offeredratelist: any;
  CanGiveQuotation: boolean = false;
  UpgradeToUnlock: boolean = false;
  userid: string = "";
  raterqueststatus: any;
  stateParams: any;
  display = 'none';
  //  raterequestList :any
  raterequestList: any[] = [];
  public selectedstatusName: any;
  myValue: RaterequestStatus;
  options: string[];
  RaterequestStatus: typeof RaterequestStatus = RaterequestStatus;
  selectrateStatus: any;
  Isopenpopup = false;
  status: number = 0;
  selected: any;
  raterequetdata: any;
  canbook = false;
  contactName: string;
  contactEmail: string;
  phoneNumber: string;
  viewoffer = false;
  //totalamount: number = 2;
  totalamount: number = BookingFeeAndLumpsum.BookingFee;
  offeredrateidforbooking: number = 0;
  cargoclassname: string;
  cargosegmentname: string;
  conditionname: string;
  whencargocanlandportname: string;
  numberofunitname: string;
  shippinglinename: string;
  cargolength: string;
  cargowidth: string;
  cargoheight: string;
  cargoweight: string;
  packageAndDescription: string;
    yesButtonText = 'Yes';
  noButtonText = 'No'
  // submitted = false;
  ratererequestform = this.fb.group({
    resonforrerequest: ['', Validators.required],
  })

  fileNames: any[] = [];
  downloadBaseUrl:string;
  cargoMovementStatus:string;
  durationFilterOptions:Record<DurationFilter, string> = GetDurationFilterValues;
  durationValues =  Object.values(DurationFilter).filter(value => typeof value === 'number');
  selectedDuration  = 1;
  showUserDetails:boolean=false;
  @ViewChild('viewRateRequestModal', { static: false }) viewRateRequestModal: any;
  @ViewChild('viewOfferedRateModal', { static: false }) viewOfferedRateModal: any;
  @ViewChild('viewOfferedRateViewModal', { static: false }) viewOfferedRateViewModal: any;
  @ViewChild('viewReRequestModal', { static: false }) viewReRequestModal: any;

  modalRef: NgbModalRef | null = null;

  public ClientID = environment.clientID;

  RateForm = this.fb.group({
    noOfUnits: ['', Validators.required],
    totallanemeters: ['', Validators.required],
    totalCubicmeters: ['', Validators.required],
    freightrate: ['', Validators.required],
    freightratebasis: ['', Validators.required],
    othercharges: ['', Validators.required],
    otherchargesbasis: ['', Validators.required],
    baf: ['', Validators.required],
    bafbasis: ['', Validators.required],
    caf: [''],
    cafbasis: ['', Validators.required],
    thc: ['', Validators.required],
    thcbasis: ['', Validators.required],
    totalsumofallcost: ['', Validators.required],
    costperunit: ['', Validators.required],
    costpercubicmeter: ['', Validators.required],
    freightratevalidity: ['', Validators.required],
    freightratetotal: [''],
    ratetotal: [''],
    baftotal: [''],
    caftotal: [''],
    thctotal: [''],
    otherchargestotal: [''],
    disclaimer: ['']
  });
  constructor(private fb: FormBuilder,
    private bookingService: BookingService,
    private raterequestservice: RateRequestService, private confirmationService: ConfirmationService, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService,
    private datePipe: DatePipe, private activatedRoute: ActivatedRoute,
    private portservice: PortService,
  private userService: UserService,private modalService: NgbModal) {
      this.downloadBaseUrl = environment.apiUrl+"api/Upload/DownloadFreightDocument/";
    this.raterequestservice.getRateRequestDropdown().subscribe(data => this.ratedropdown.push(...data));
    this.activatedRoute.paramMap.subscribe((params: any) => {
      this.stateParams = params.params.id;
      this.viewoffer = params.params.viewoffer == "true" ? true : false;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    });
  }
  statusValue(value: string) {
    this.myValue = RaterequestStatus[value];
    if (this.selectrateStatus != null && this.selectrateStatus != undefined && this.selectrateStatus.length > 0) {
      this.currentPage = 1;
      this.pageSize = 10;
      this.status = parseInt(RaterequestStatus[this.selectrateStatus]);

    }
    else {
      this.currentPage = 1;
      this.pageSize = 10;
      this.status = parseInt(RaterequestStatus[this.selectrateStatus]);
    }
    this.RateRequestListData();
  }

  onDurationChange(value){
    this.currentPage = 1;
      this.pageSize = 10;
    this.RateRequestListData();
  }

  ngOnInit() {
    this.currentUser = JSON.parse(String(localStorage.getItem('currentUser')));
    if (this.currentUser && this.currentUser.usersDetailsVM.userRole == UserRole.SuperAdmin) {
      this.isadmin = true;
      this.CanGiveQuotation = true;
      this.getUserPlan();
    }
    else if(this.currentUser) {
      this.CanGiveQuotation = this.currentUser.usersDetailsVM.planId == UserSelectedPlan.Elite 
      || this.currentUser.usersDetailsVM.planId == UserSelectedPlan.ProPlus
      || this.currentUser.usersDetailsVM.planId == UserSelectedPlan.Pro ? true : false;
      this.UpgradeToUnlock = this.currentUser.usersDetailsVM.planId == UserSelectedPlan.Advanced 
      || this.currentUser.usersDetailsVM.planId == UserSelectedPlan.Basic ? true : false;
      this.userid = this.CanGiveQuotation == true ? this.currentUser.usersDetailsVM.userId : "";
      this.getUserPlan();
    }
    else {
      this.UpgradeToUnlock = true;
    }
    
    this.pageSize = 10;
    this.currentPage = 1;
    this.minDate = new Date();
    this.rageYears = this.minDate.getUTCFullYear() + ':' + (this.minDate.getUTCFullYear() + 50);
    this.RateRequestListData();
    this.raterqueststatus = RaterequestStatus;
    if (this.stateParams != 0 && this.stateParams != undefined && this.viewoffer == false) {
      this.OpenOfferedRatePopup(this.stateParams);
    }
    else if (this.viewoffer == true) {
      this.getAllofferedrate(parseInt(this.stateParams));
    }
    // let currentUser = JSON.parse(String(localStorage.getItem('currentUser'))); 
    var x = RaterequestStatus;
    var options = Object.keys(RaterequestStatus);
    this.options = options.slice(options.length / 2);
    this.selectrateStatus = options[6];
  }

   getUserPlan() {
    if(this.isadmin){
      this.showUserDetails=true;
    }else{
      this.userService.getUserPlan(this.currentUser.usersDetailsVM.id).subscribe((result: any) => {
       if(result && result.planId== 5){
        this.showUserDetails=true;
       }
      });
    }
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.RateForm.controls[controlName].hasError(errorName);
  }

  public hasErrors = (controlName: string, errorName: string) => {
    return this.ratererequestform.controls[controlName].hasError(errorName);
  }

  @ViewChild('closeRateModal') closeRateModal: ElementRef;
  @ViewChild('closeRateModalsub') closeRateModalsub: ElementRef;
  @ViewChild('closeratererequestform') closeratererequestform: ElementRef;

  RateRequestListData() {
    this.spinner.show();
    this.raterequestservice.AllRateRequestList(this.currentPage, this.pageSize, this.SerachField, this.status,this.selectedDuration).subscribe((response: any) => {
      if (response != null && response.isSuccess == true && response.content != null) {
        this.RatelistData = response.content.content;
        if (this.RatelistData != null && this.RatelistData.length != 0) {
          if (this.currentUser && this.currentUser.usersDetailsVM.id == this.RatelistData[0].userId) {
            this.IsRateEdit = true;
          }
        }
        this.totalcount = response.content.totalCount;
        this.spinner.hide();
      }
      this.spinner.hide();
    },
  err=>{
    if(err && err.error.message){
        this.confirm(err.error.message);
      }
  })
  }
  confirm(message, yesButtonText = 'Upgrade', noButtonText = 'No') {
    this.yesButtonText = yesButtonText;
    this.noButtonText = noButtonText;
    this.confirmationService.confirm({
      message: message,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.router.navigateByUrl('/planselection');
      },
      reject: () => {
      }
    });
  }

  upgradePlan(planType) {
    this.modalRef.close();
    this.router.navigate(
      ['/planselection'],
      { queryParams: { plan: planType } }   
    );
  }

  AddRateRequest() {
    // let id = 0;
    let url = '/raterequest/' + 0;
    this.router.navigate([url]);
  }

  editRaterequest(id) {
    let url = '/raterequest/' + id;
    this.router.navigate([url]);
  }

 openRateRequestModal(id, frmport, toport, status, offerdrateid) {
  this.GetRateData(id, frmport, toport, status, offerdrateid)
  this.modalRef = this.modalService.open(this.viewRateRequestModal, {
      size: 'lg',
      centered: true,
      backdrop: 'static'
    });
  }

  openOfferedRateModal(id) {
    if(!this.currentUser){
      this.toastr.info('Details are available for registered ENL members only.', '', {positionClass: 'toast-top-center'});
    }
    this.getAllofferedrate(id)
    this.modalRef = this.modalService.open(this.viewOfferedRateModal, {
        size: 'lg',
        centered: true,
        backdrop: 'static'
      });
  }

  openViewOfferedRateViewModal(id, frmport, toport, offerdrateId) {
  this.GetOfferdRate(id, frmport, toport, offerdrateId);
  this.modalRef = this.modalService.open(this.viewOfferedRateViewModal, {
      size: 'lg',
      centered: true,
      backdrop: 'static'
    });
  }
  
  openViewReRequestModal() {
    this.modalRef = this.modalService.open(this.viewReRequestModal, {
        size: 'lg',
        centered: true,
        backdrop: 'static'
      });
  }

  GetRateData(id, frmport, toport, status, offerdrateid) {
    this.submitted = false;
    this.RateForm.reset();
    this.offeredamount = 0;
    this.RateRequsetId = id;
    this.frmport = frmport;
    this.toport = toport;
    this.statusrate = status;
    this.raterequestservice.GetRateRequest(id).subscribe((response: any) => {
      if (response != null && response.isSuccess == true && response.content != null) {
        let newDate = new Date(response.content[0].cargoLoadPortDate);
        this.RateForm.controls.noOfUnits.setValue(response.content[0].noOfUnits);
        this.RateForm.controls.totallanemeters.setValue(response.content[0].noOfUnits * response.content[0].length as any);
        this.RateForm.controls.totalCubicmeters.setValue(response.content[0].cbm);
        this.whencargocanlandportname = response.content[0].cargoLoadPortDate;
        this.getMasterCargoClass(response.content[0].cargoType);
        this.getMasterCargoSegments(response.content[0].cargoSegment);
        this.getMasterCargoMovementStatus(response.content[0].cargoMovementStatus);
        this.fileNames = response.content[0].fileNames;
        this.conditionname = response.content[0].condition == 1 ? 'New' : 'Used';
        this.numberofunitname = response.content[0].noOfUnits;
        this.getshippingline(response.content[0].shippingLineId);
        // get more info like len,ht, wt
        this.cargolength = response.content[0].length;
        this.cargowidth = response.content[0].width;
        this.cargoheight = response.content[0].height;
        this.cargoweight = response.content[0].weight;
        this.packageAndDescription = response.content[0].cargopackageDescription;
        this.rateRequestUserDetail= response.content[0].userDetail;

      }
      else {
        this.toastr.error('Something went wrong!', 'Oops!!');
      }
      this.freightratedropdown = this.ratedropdown.filter(x => x.Israte != "2");
      this.otherratedropdown = this.ratedropdown.filter(x => x.Israte != "1");

      var lumpsum = this.otherratedropdown.filter(x => x.value == BookingFeeAndLumpsum.Lumpsum.toString())
      this.RateForm.controls.cafbasis.setValue(lumpsum[0].value);
      this.RateForm.controls.caf.setValue(0 as any);
      this.RateForm.controls.caftotal.setValue(0 as any);

    });
  }

  GetOfferdRate(id, frmport, toport, offerdrateId) {
    // this.closeratererequestform.nativeElement.click();
    this.modalRef.close();
    this.modalRef.close();
    this.RateForm.reset();
    this.RateRequsetId = id;
    this.frmport = frmport;
    this.toport = toport;
    this.freightratedropdown = this.ratedropdown.filter(x => x.Israte != "2");
    this.otherratedropdown = this.ratedropdown.filter(x => x.Israte != "1");
    this.raterequestservice.Getofferedratedet(id, offerdrateId).subscribe((response: any) => {
      if (response != null && response.isSuccess == true && response.content != null) {
        let newDate = new Date(response.content.freightRateValidity);
        this.contactName = response.content.firstName + ' ' + response.content.lastName;
        this.contactEmail = response.content.email;
        this.phoneNumber = response.content.phoneNumber;
        var selectedBAF = this.ratedropdown.filter(x => x.value == response.content.rateBasisBAF);
        var selectedRate = this.ratedropdown.filter(x => x.value == response.content.rateBasisFreightRate);
        var selectedCaf = this.ratedropdown.filter(x => x.value == response.content.rateBasisCAF);
        var selectedThc = this.ratedropdown.filter(x => x.value == response.content.rateBasisTHC);
        var selectedOthercharges = this.ratedropdown.filter(x => x.value == response.content.rateBasisOtherChareges);
        this.selectedCafname = selectedCaf[0].label;
        this.selectedBAFname = selectedBAF[0].label;
        this.selectedRatename = selectedRate[0].label;
        this.selectedThcname = selectedThc[0].label;
        this.selectedOtherchargesname = selectedOthercharges[0].label;
        this.offeredRateReason = response.content.reasonForReRequest;
        this.RateForm = this.fb.group({
          noOfUnits: [response.content.totalNumberOfUnits],
          totallanemeters: [response.content.totalLandMeter],
          totalCubicmeters: [response.content.totalCubicMeter],
          freightrate: [response.content.freightRate],
          freightratebasis: [selectedRate[0].value],
          othercharges: [response.content.otherCharges],
          otherchargesbasis: [selectedOthercharges[0].value],
          baf: [response.content.baf],
          bafbasis: [selectedBAF[0].value],
          caf: [response.content.caf],
          cafbasis: [selectedCaf[0].value],
          thc: [response.content.thc],
          thcbasis: [selectedThc[0].value],
          totalsumofallcost: [response.content.totalFreightCost],
          costperunit: [response.content.costPerUnit],
          costpercubicmeter: [response.content.costPerCubicMeter],
          freightratevalidity: [newDate],
          ratetotal: [response.content.ratetotal],
          baftotal: [response.content.baftotal],
          caftotal: [response.content.caftotal],
          thctotal: [response.content.thctotal],
          otherchargestotal: [response.content.otherchargestotal],
          disclaimer: [response.content.disclaimer]
        }) as any;
        this.offeredamount = parseFloat(response.content.totalFreightCost.toFixed(0.00));
        // this.RateForm.controls.bafbasis.setValue(selectedBAF[0].value);            
      }
      else {
        this.toastr.error('Something went wrong!', 'Oops!!');
      }
    });
  }

  SubmitRate() {
    this.submitted = true;
    if (this.RateForm.invalid) {
      if (parseFloat(this.RateForm.controls.costpercubicmeter.value) == 0) {
        this.toastr.warning('Cost Per Cubic Meter Should be Greter than 0 .', 'Oops !');
      }
      this.toastr.warning('Please Enter All the Required Fields.', 'Oops !');
      return;
    }
    else {
      this.spinner.show();
      let model = new OfferedRateModel();
      model.Id = this.offeredRateId == null ? 0 : this.offeredRateId;
      model.BAF = parseFloat(this.RateForm.controls.baf.value);
      model.RateBasisBAF = parseFloat(this.RateForm.controls.bafbasis.value);
      model.CAF = parseFloat(this.RateForm.controls.caf.value);
      model.CostPerCubicMeter = parseFloat(this.RateForm.controls.costpercubicmeter.value);
      model.CostPerUnit = parseFloat(this.RateForm.controls.costperunit.value);
      model.FreightRate = parseFloat(this.RateForm.controls.freightrate.value);
      let convdate = this.dateConvert(this.RateForm.controls.freightratevalidity.value);
      model.FreightRateValidity = new Date(convdate);
      model.OtherCharges = parseFloat(this.RateForm.controls.othercharges.value);
      model.RateBasisCAF = parseFloat(this.RateForm.controls.cafbasis.value);
      model.RateBasisFreightRate = parseFloat(this.RateForm.controls.freightratebasis.value);
      model.RateBasisOtherChareges = parseFloat(this.RateForm.controls.otherchargesbasis.value);
      model.RateBasisTHC = parseFloat(this.RateForm.controls.thcbasis.value);
      model.RateRequestId = parseInt(this.RateRequsetId);
      model.THC = parseFloat(this.RateForm.controls.thc.value);
      model.TotalCubicMeter = parseFloat(this.RateForm.controls.totalCubicmeters.value);
      model.TotalFreightCost = parseFloat(this.RateForm.controls.totalsumofallcost.value);
      model.TotalLandMeter = parseFloat(this.RateForm.controls.totallanemeters.value);
      model.TotalNumberOfUnits = parseFloat(this.RateForm.controls.noOfUnits.value);
      model.ratetotal = parseFloat(this.RateForm.controls.ratetotal.value);
      model.Baftotal = parseFloat(this.RateForm.controls.baftotal.value);
      model.Caftotal = parseFloat(this.RateForm.controls.caftotal.value);
      model.Otherchargestotal = parseFloat(this.RateForm.controls.otherchargestotal.value);
      model.Thctotal = parseFloat(this.RateForm.controls.thctotal.value);
      model.CreatedBy = this.currentUser.usersDetailsVM.userId;
      model.Disclaimer = this.RateForm.controls.disclaimer.value;
      this.raterequestservice.SaveFreightRate(model).subscribe((response: any) => {
        if (response != null && response.isSuccess == true && response.content != null) {
          // this.closeRateModalsub.nativeElement.click();
          this.modalRef.close();
          this.spinner.hide();
          this.toastr.success('Rate Request Has been Send Sucessfully..!', '');
        }
        this.spinner.hide();
        this.RateRequestListData();
      })
    }
  }

  dateConvert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  SubmitReason() {
    this.submitted = true;
    if (this.ratererequestform.invalid) {
      this.toastr.warning('Please Enter Enter the Reason.', 'Oops !');
      return;
    }
    else {
      this.raterequestservice.SavedRerequestComment(this.RateRequsetId, this.ratererequestform.controls.resonforrerequest.value).subscribe((response: any) => {
        if (response != null && response.isSuccess == true && response.content == null) {
          // this.closeRateModal.nativeElement.click();
          // this.closeratererequestform.nativeElement.click();
          this.modalRef.close();
          this.ratererequestform.reset();
          this.toastr.success('Rate Has been Requested..!', '');
          this.RateRequestListData();
        }
        else {
          // this.closeRateModal.nativeElement.click();
          this.modalRef.close();
          // this.closeratererequestform.nativeElement.click();
          this.ratererequestform.reset();
          this.toastr.error('Rate Request  not Saved!', 'Oops');
        }
      })
    }
  }

  DeleteRateRequest(id) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to Delete this Rate ?',
      accept: () => {
        this.raterequestservice.DeleteRateRequest(id).subscribe((response: any) => {
          if (response != null && response.isSuccess == true && response.content != null) {
            this.toastr.success('Record Deleted Sucessfully.');
            this.RateRequestListData();
          }
          else {
            this.toastr.warning('You Can not Delete This Request.');
          }
        })
      }
    });
  }

  Calculatetotalfreightrate() {
    let val = this.RateForm.controls.freightratebasis.value
    let value = val == "1" ? parseFloat(this.RateForm.controls.freightrate.value) * parseFloat(this.RateForm.controls.noOfUnits.value)
      : val == "2" ? parseFloat(this.RateForm.controls.freightrate.value) * parseFloat(this.RateForm.controls.totalCubicmeters.value)
        : val == "3" ? parseFloat(this.RateForm.controls.freightrate.value) * parseFloat(this.RateForm.controls.totallanemeters.value)
          : val == "4" ? 1 * parseFloat(this.RateForm.controls.freightrate.value)
            : parseFloat(this.RateForm.controls.freightrate.value);
    $(".totalrate").val(parseFloat(value.toFixed(2)));
    this.RateForm.controls.ratetotal.setValue(value.toFixed(2) == 'NaN' ? 0 : value.toFixed(2) as any);
    this.Calculatetotal();
  }

  CalculatetotalBAFtrate() {
    let val = this.RateForm.controls.bafbasis.value;
    let value = val == "1" ? parseFloat(this.RateForm.controls.baf.value) * parseFloat(this.RateForm.controls.noOfUnits.value)
      : val == "2" ? parseFloat(this.RateForm.controls.baf.value) * parseFloat(this.RateForm.controls.totalCubicmeters.value)
        : val == "3" ? parseFloat(this.RateForm.controls.baf.value) * parseFloat(this.RateForm.controls.totallanemeters.value)
          : val == "4" ? 1 * parseFloat(this.RateForm.controls.baf.value) :
            val == "5" ? parseFloat(this.RateForm.controls.ratetotal.value) * parseFloat(this.RateForm.controls.baf.value) / 100
              : parseFloat(this.RateForm.controls.baf.value);
    $(".totalbaf").val(value.toFixed(2) == 'NaN' ? 0 : value.toFixed(2));
    this.RateForm.controls.baftotal.setValue(value.toFixed(2) == 'NaN' ? 0 : value.toFixed(2) as any);
    this.Calculatetotal();
  }

  CalculatetotalCAFrate() {
    let val = this.RateForm.controls.cafbasis.value;
    let value = val == "1" ? parseFloat(this.RateForm.controls.caf.value) * parseFloat(this.RateForm.controls.noOfUnits.value)
      : val == "2" ? parseFloat(this.RateForm.controls.caf.value) * parseFloat(this.RateForm.controls.totalCubicmeters.value)
        : val == "3" ? parseFloat(this.RateForm.controls.caf.value) * parseFloat(this.RateForm.controls.totallanemeters.value)
          : val == "4" ? 1 * parseFloat(this.RateForm.controls.caf.value) :
            val == "5" ? parseFloat(this.RateForm.controls.ratetotal.value) * parseFloat(this.RateForm.controls.caf.value) / 100
              : parseFloat(this.RateForm.controls.caf.value);
    $(".totalcaf").val(value.toFixed(2));
    this.RateForm.controls.caftotal.setValue(value.toFixed(2) == 'NaN' ? 0 : value.toFixed(2) as any);
    this.Calculatetotal();
  }

  CalculatetotalTHCrate() {
    let val = this.RateForm.controls.thcbasis.value;
    let value = val == "1" ? parseFloat(this.RateForm.controls.thc.value) * parseFloat(this.RateForm.controls.noOfUnits.value)
      : val == "2" ? parseFloat(this.RateForm.controls.thc.value) * parseFloat(this.RateForm.controls.totalCubicmeters.value)
        : val == "3" ? parseFloat(this.RateForm.controls.thc.value) * parseFloat(this.RateForm.controls.totallanemeters.value)
          : val == "4" ? 1 * parseFloat(this.RateForm.controls.thc.value)
            : val == "5" ? parseFloat(this.RateForm.controls.ratetotal.value) * parseFloat(this.RateForm.controls.thc.value) / 100
              : parseFloat(this.RateForm.controls.thc.value);

    $(".totalthc").val(parseFloat(value.toFixed(2)));
    this.RateForm.controls.thctotal.setValue(value.toFixed(2) == 'NaN' ? 0 : value.toFixed(2) as any);
    this.Calculatetotal();
  }

  Calculatetotalothercharges() {
    let val = this.RateForm.controls.otherchargesbasis.value;
    let value = val == "1" ? parseFloat(this.RateForm.controls.othercharges.value) * parseFloat(this.RateForm.controls.noOfUnits.value)
      : val == "2" ? parseFloat(this.RateForm.controls.othercharges.value) * parseFloat(this.RateForm.controls.totalCubicmeters.value)
        : val == "3" ? parseFloat(this.RateForm.controls.othercharges.value) * parseFloat(this.RateForm.controls.totallanemeters.value)
          : val == "4" ? 1 * parseFloat(this.RateForm.controls.othercharges.value)
            : val == "5" ? parseFloat(this.RateForm.controls.ratetotal.value) * parseFloat(this.RateForm.controls.othercharges.value) / 100
              : parseFloat(this.RateForm.controls.othercharges.value);
    $(".totalothercharges").val(parseFloat(value.toFixed(2)));
    this.RateForm.controls.otherchargestotal.setValue(value.toFixed(2) == 'NaN' ? 0 : value.toFixed(2) as any);
    this.Calculatetotal();
  }

  Calculatetotal() {
    let total =
      parseFloat($(".totalbaf").val()) +
      parseFloat($(".totalrate").val()) +
      parseFloat($(".totalothercharges").val()) +
      parseFloat($(".totalthc").val()) +
      parseFloat($(".totalcaf").val());
    this.RateForm.controls.totalsumofallcost.setValue(total.toFixed(2) == 'NaN' ? 0 : total.toFixed(2) as any);
    let costperunit = total / (this.RateForm.controls.noOfUnits as any)?.value;
    this.RateForm.controls.costperunit.setValue(costperunit.toFixed(2) == 'NaN' ? 0 : costperunit.toFixed(2) as any);
    let costpercubicmeter = total / (this.RateForm.controls.totalCubicmeters as any)?.value;
    this.RateForm.controls.costpercubicmeter.setValue(costpercubicmeter.toFixed(2) == 'NaN' ? 0 : costpercubicmeter.toFixed(2) as any);
    this.offeredamount = parseFloat(this.RateForm.controls.totalsumofallcost.value);
  }

  ngAfterViewInit(): void {

    $(document).on('keydown', 'input[pattern]', function (e) {
      var input = $(this);
      var oldVal = input.val();
      var regex = new RegExp(input.attr('pattern'), 'g');
      setTimeout(function () {
        var newVal = input.val();
        if (!regex.test(newVal)) {
          input.val(oldVal);
        }
      }, 0);
    });
  }

  private loadExternalScript(scriptUrl: string) {
    return new Promise((resolve, reject) => {
      const scriptElement = document.createElement('script')
      scriptElement.src = scriptUrl
      scriptElement.onload = resolve
      document.body.appendChild(scriptElement)
    })
  }

  paginate(event) {
    this.currentPage = event.page + 1;
    this.pageSize = event.rows;
    this.RateRequestListData();
  }

  filterSearch(msg) {
    this.SerachField = msg;
    this.currentPage = 1;
    this.RateRequestListData();
  }

  getAllofferedrate(ratereeqId) {
    this.raterequestservice.GetAllOfferedRatesList(ratereeqId, this.currentUser.usersDetailsVM.userId).subscribe((response: any) => {
      if (response != null && response.isSuccess == true && response.content != null) {
        if (this.viewoffer == true) {
          $("#openpopupNew").click();
          this.viewoffer = false;
        }
        this.offeredratelist = response.content;
        if (this.offeredratelist.length > 0) {
          this.canbook = this.offeredratelist[0].userId == parseInt(this.currentUser.usersDetailsVM.id) ? true : false;
        }
        else {
          this.canbook = false;
        }
        //this.closeRateModal.nativeElement.click();
        //this.toastr.success('Rate Request Has been Send Sucessfully..!', '');
      }
    })
  }

  OpenOfferedRatePopup(id) {
    this.RateForm.reset();
    this.offeredamount = 0;
    this.RateRequsetId = parseInt(id);
    if (this.CanGiveQuotation) {
      this.Isopenpopup = true;
      this.raterequestservice.GetRateRequest(id).subscribe((response: any) => {
        if (response != null && response.isSuccess == true && response.content != null && response.content.length > 0) {
          $("#openpopup").click();
          this.Isopenpopup = false;
          this.frmport = response.content[0].fromPortName;
          this.toport = response.content[0].toPortName;
          let newDate = new Date(response.content[0].cargoLoadPortDate);
          this.RateForm.controls.noOfUnits.setValue(response.content[0].noOfUnits);
          this.RateForm.controls.totallanemeters.setValue((response.content[0] .noOfUnits * response.content[0].length) as any);
          this.RateForm.controls.totalCubicmeters.setValue(response.content[0].cbm);
          // this.router.navigate(["/raterequestlist/0"]);
        }
        else {
          this.Isopenpopup = false;
          this.toastr.warning('Your are not allowed to Offer a rate to this rate Request.', 'Oops!!');
        }
        this.freightratedropdown = this.ratedropdown.filter(x => x.Israte != "2");
        this.otherratedropdown = this.ratedropdown.filter(x => x.Israte != "1");
      });
    }
  }

  resetvalues() {
    this.submitted = false;
  }

  OnRateSelection() {
    var vales = this.selected;
    if (this.selected != undefined && this.selected != null && this.selected != '') {
      var selectedData = this.offeredratelist.filter(x => x.offeredRateId == this.selected);
      if (selectedData != null) {
        this.raterequestservice.GetRateRequest(selectedData[0].rateRequestId).subscribe((response: any) => {
          if (response != null && response.isSuccess == true && response.content != null) {
            this.raterequetdata = response.content[0];
           // this.totalamount = selectedData[0].totalOfferedRate;
           this.totalamount = BookingFeeAndLumpsum.BookingFee;
            this.offeredrateidforbooking = selectedData[0].offeredRateId;
            // this.totalamount1 = this.totalamount;
            // alert(this.totalamount1);
            //  this.SaveBookingDetails(selectedData[0].offeredRateId);
            // $("#closemodel").click();
            const request: BookingRequestVM = {
              toEmail: selectedData[0].offeredByEailId,
              userName: selectedData[0].firstName + ' ' + selectedData[0].lastName,
              quoteId: selectedData[0].rateRequestId,
              pol: selectedData[0].fromPortName,
              pod: selectedData[0].toPortName,
              company: this.raterequetdata.userDetail.companyName,
              contact: this.raterequetdata.userDetail.firstName + ' ' + this.raterequetdata.userDetail.lastName,
              phone: this.raterequetdata.userDetail.phoneNumber,
              fromEmail: this.raterequetdata.userDetail.email,
              pcs: this.raterequetdata.noOfUnits,
              height: this.raterequetdata.height,
              width: this.raterequetdata.width,
              length: this.raterequetdata.length,
              weight: this.raterequetdata.weight,
              sailingDate: this.raterequetdata.cargoLoadPortDate,
              price: selectedData[0].totalOfferedRate,
              validity: selectedData[0].freightRateValidTill
            };
            this.raterequestservice.SendBookingRequestEmail(request).subscribe((response: any) => {
              if (response && response.success) {
                this.modalRef.close();
                this.toastr.success('Booking Rate Request has been sent sucessfully.', '');
              }
            })
            // this.loadbuttons();  // this is commented as part of booking request email sent and removing paypal
          }
        });
      }
      //  this.(selectedData[0].rateRequestId, selectedData[0].offeredRateId);
      //this.rateselected = true;
    }
    else {
      this.toastr.warning("Please Select the Shipping Cost");
      //$("#closepoup").click();
    }
  }

  loadbuttons() {
    const self = this;
    $("#openModalButton").click();
    this.loadExternalScript("https://www.paypal.com/sdk/js?client-id=" + this.ClientID).then(() => {
      paypal.Buttons({
        // env: 'sandbox',
        // client: {
        //   production: '',
        //   sandbox: 'Ac4PhNZyyz-tvi-lWEU6R8UEfId5fUCLl6y26YecV87fEeOI_EpFutelFMFi0SdZEQN5_cYOA15JObsI'
        // },
        // commit: true,
        createOrder: function (data, actions) {
          let amountval = $(".data").val();
          // This function sets up the details of the transaction, including the amount and line item details.
          return actions.order.create({
            purchase_units: [{
              amount: {
                value: BookingFeeAndLumpsum.BookingFee// amountval
              }
            }]
          });
        },
        onApprove: function (data, actions) {
          $("#closepoup").click();
          // This function captures the funds from the transaction.
          return actions.order.capture().then(function (details) {
            // This function shows a transaction success message to your buyer.
            // console.log('paymentdetails',details);
            self.SaveBookingDetails(details);
            let event = new CustomEvent('dosomething', details);
            // alert('Transaction completed by ' + details.payer.name.given_name);
          });
        },
        onError: function (err) {
          self.toastr.error('Something went wrong!', 'Oops!!');
          // Show an error page here, when an error occurs
        }
        // payment: function (data, actions) {
        //   alert();
        //   return actions.payment.create({
        //     payment: {
        //       transactions: [
        //         {                 
        //           amount: { total: '1.00', currency: 'USD' }
        //         }
        //       ]
        //     }
        //   })
        // },
        // onAuthorize: function(data, actions) {
        //   return actions.payment.execute().then(function(payment) {
        //     // TODO
        //   })
        // }
      }).render('#paypal-button-container');
    });
  }

  SaveBookingDetails(details: any) {
    this.spinner.show();
    let model = new BookingViewModel();
    let paymentdetails = new PaymentDetails();
    model.FromCountryId = parseInt(this.raterequetdata.fromCountryId);
    model.FromPortId = parseInt(this.raterequetdata.fromPortId);
    model.OfferedRateId = this.offeredrateidforbooking;
    model.RateRequestId = this.raterequetdata.id;
    model.ShippingLineId = parseInt(this.raterequetdata.shippingLineId);
    model.TermsAndCondition = true;
    model.ToCountryId = parseInt(this.raterequetdata.toCountryId);
    model.ToPortId = parseInt(this.raterequetdata.toPortId);
    //model.VesselsId = parseInt(this.stateParams.vesselsId);
    //model.VoyageId = parseInt(this.stateParams.id);
    model.CreatedBy = this.currentUser.usersDetailsVM.userId;
    /////Save Payment Details/////
    paymentdetails.TransactionId = details.purchase_units[0].payments.captures[0].id;
    paymentdetails.CreatedDate = details.purchase_units[0].payments.captures[0].create_time;
    paymentdetails.Status = details.purchase_units[0].payments.captures[0].status;
    paymentdetails.AmountDebited = details.purchase_units[0].payments.captures[0].amount.value;
    paymentdetails.EmailId = details.payer.email_address;
    paymentdetails.PayerID = details.payer.payer_id;
    paymentdetails.FullName = details.purchase_units[0].shipping.name.full_name;
    paymentdetails.CreatedBy = model.CreatedBy;
    model.paymentdetails = paymentdetails;
    this.bookingService.SaveBookingDetails(model).subscribe((response: any) => {
      if (response.result != null && response.result.isSuccess == true && response.result.content != null) {
        this.spinner.hide()
        this.router.navigate(['/bookinglist']);
        this.toastr.success('Your booking request has been sent.', 'Awaiting booking confirmation!!');
      }
      else {
        this.spinner.hide();
        this.toastr.error('Something went wrong!', 'Oops!!');
      }
    });
  }

  getshippingline(shippinglinid) {
    this.portservice.GetShippingLines().subscribe((response: any) => {
      if (response != null && response.content != null) {
        var selectedShips = response.content.filter(x => x.shippingLineId == shippinglinid);
        this.shippinglinename = selectedShips[0].shippingLineName;
      }
    });
  }

  getMasterCargoClass(cargoid) {
    this.spinner.show();
    this.bookingService.getMasterCargoClass().subscribe((response: any) => {
      if (response != null && response.content != null && response.content.length > 0) {
        //  this.cargoTypes = response.content;
        let cargotype = response.content.filter(x => x.id == parseInt(cargoid));
        //this.ratereqform.controls.cargoclass.setValue(cargotype[0]);
        this.cargoclassname = cargotype[0].name;
      }
      this.spinner.hide();
    })
  }

  getMasterCargoSegments(segmentid) {
    this.spinner.show();
    this.bookingService.getMasterCargoSegments().subscribe((response: any) => {
      if (response != null && response.content != null && response.content.length > 0) {
        let cargotype = response.content.filter(x => x.id == parseInt(segmentid));
        this.cargosegmentname = cargotype[0].name;
      }
      this.spinner.hide();
    })
  }

  getMasterCargoMovementStatus(id) {
    this.spinner.show();
    this.bookingService.getMasterCargoMovementStatus().subscribe((response: any) => {
      if (response != null && response.content != null && response.content.length > 0) {
        let cargoMovement = response.content.filter(x => x.id == parseInt(id));
        this.cargoMovementStatus = cargoMovement[0].name;
      }
      this.spinner.hide();
    })
  }
}
